module.exports = __webpack_public_path__ + "img/logo_simple.fab23b5c.svg";